import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Container, Paper, Typography, Alert, Button, CircularProgress } from '@mui/material';
import featuredService from '../../services/featuredService';

// Leiratkozás a korai ajánlat emailjeiről. Gombnyomásra (POST) iratkozik le, hogy egy
// levelezőrendszer link-előnézete ne indíthassa el.
const EarlyOfferUnsubscribe = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('u');
  const token = searchParams.get('token');
  const [status, setStatus] = useState(userId && token ? 'confirm' : 'error'); // confirm | working | done | error
  const [message, setMessage] = useState(userId && token ? '' : 'Hiányzó vagy érvénytelen link.');

  const handleUnsubscribe = async () => {
    setStatus('working');
    try {
      await featuredService.unsubscribeEarlyOffer(userId, token);
      setStatus('done');
    } catch (err) {
      setMessage(err?.message || 'Hiba történt. Kérjük, írj a hello@wedigo.hu címre.');
      setStatus('error');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>Leiratkozás</Typography>
        {(status === 'confirm' || status === 'working') && (
          <>
            <Typography variant="body1" sx={{ my: 3 }}>
              Nem szeretnél több ajánlatot kapni tőlünk erről a lehetőségről? A fiókodat ez nem érinti.
            </Typography>
            <Button variant="contained" onClick={handleUnsubscribe} disabled={status === 'working'}>
              {status === 'working' ? <CircularProgress size={22} color="inherit" /> : 'Leiratkozom'}
            </Button>
          </>
        )}
        {status === 'done' && (
          <>
            <Alert severity="success" sx={{ my: 3, textAlign: 'left' }}>Leiratkoztál, ezután nem küldünk ilyen leveleket.</Alert>
            <Button component={Link} to="/" variant="contained">Vissza a főoldalra</Button>
          </>
        )}
        {status === 'error' && <Alert severity="error" sx={{ my: 3, textAlign: 'left' }}>{message}</Alert>}
      </Paper>
    </Container>
  );
};

export default EarlyOfferUnsubscribe;
